export const environment = {
  production: false,
  // Empty string routes /api/* calls through the Angular CLI proxy (proxy.conf.json) in local dev.
  // On non-localhost dev deployments the proxy is not available, so use the backend URL directly.
  apiBaseUrl:
    typeof window !== 'undefined' &&
    window.location.hostname !== 'localhost' &&
    window.location.hostname !== '127.0.0.1'
      ? 'https://tcocet-backend-dev-new.azurewebsites.net'
      : '',
  auth: {
    tenantId: 'fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
    clientId: '1cc4c7ff-6099-412b-9126-effe871eec20',
    scopes: ['https://tcocet-test.azure.chevron.com/user_impersonation'],
  },
};
